/* eslint-disable simple-import-sort/imports */
import { ApolloProvider } from "@apollo/client";
import type { FC } from "react";
import { OverlayProvider } from "react-aria";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";

// ! Keep it before App.tsx
import { apolloClient, router, store } from "@/setup.ts";

import { authenticatedAndLoadUserSession, logout } from "@/redux/modules/auth.ts";
import setup from "@/tools.ts";
import { storage } from "widgets";
import { BroadcastLogoutProxy } from "@selector/shared/components";
import { messages } from "@selector/shared";
import { TOKEN_KEY } from "@selector/shared/settings";

const token = storage[TOKEN_KEY];

if (token) {
  store.dispatch(authenticatedAndLoadUserSession(token));
}

try {
  setup.setStore(store);
  setup.setClient(apolloClient);
  setup.setRouter(router);
} catch (error) {
  if (import.meta.env.DEV) {
    console.warn(error);
  }
}

export const Selector: FC = () => {
  return (
    // <StrictMode>
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <OverlayProvider>
          <IntlProvider messages={messages} locale="en-US" defaultLocale="en-US">
            <BroadcastLogoutProxy
              onLogout={() => {
                store.dispatch(logout());
              }}
            >
              <RouterProvider router={router} />
            </BroadcastLogoutProxy>
          </IntlProvider>
        </OverlayProvider>
      </Provider>
    </ApolloProvider>
    // </StrictMode>
  );
};
